import { db } from "../model";
import { useLiveQuery } from "dexie-react-hooks";

async function addProjects(projects) {
  const username = localStorage.getItem("username");
  const user = await db.users.where("username").equals(username).first();
  await db.projects.clear();
  await db.datasets.clear();
  const userId = user.id;

  const projectsToInsert = [];

  for (const project of projects) {
    const existingProject = await db.projects
      .where("uuid")
      .equals(project.id)
      .first();

    if (!existingProject) {
      projectsToInsert.push({
        userID: userId,
        name: project.name,
        uuid: project.id,
      });
    }
  }

  if (projectsToInsert.length > 0) {
    await db.projects.bulkPut(projectsToInsert);
    console.log("New projects stored in the database.");
  } else {
    console.log("No new projects to insert");
  }
}

async function GetProjects() {
  const username = localStorage.getItem("username");
  const user = await db.users.where("username").equals(username).first();

  if (user) {
    const storedProjects = await db.projects
      .where("userID")
      //Need to fix this, these user models have weird relationships
      .equals(user.id)
      .toArray();
    return storedProjects;
  } else {
    return [];
  }
}

async function getProjectByUUID(uuid) {
  const dataset = await db.projects.where("uuid").equals(uuid).first();
  return dataset;
}

export { addProjects, GetProjects, getProjectByUUID };
